<template>
  <!-- <span :class="statusClass">{{statusName}}</span> -->
  <div :class="halfColumn?'cell-main-row-half':'cell-main-row'">
    <div class="cell-main-row-left van-ellipsis">{{label}}</div>
    <div class="cell-main-row-right" :class="statusClass">{{statusName}}</div>
  </div>
</template>

<script>
  export default {
    //列表页过滤下拉
    name: 'StatusColumn',
    data() {
      return {
        statusName:"",
        statusClass:"",
      }
    },
    props: {
      label:{
        type:String,
        default:"状态"
      },
      status:{

      },
      halfColumn:{
        type:Boolean,
        default:false
      }
    },
    watch: {
      status() {
        this.initStatus()
      }
    },
    methods: {
      initStatus:function(){
        let that = this
        //获得状态列表
        let statusList = this.$utils.StatusEnum.statusList
        //处理状态,statusList过滤出与projectState相同参数
        let filterList = statusList.filter(function(m) {
          return m.status == that.status
        })
        //如果有相同参数
        if (filterList.length > 0) {
          that.statusName = filterList[0].statusName
          that.statusClass = filterList[0].statusClass
        }
      }
    },
    mounted: function() {
      this.initStatus()
    }
  }
</script>

<style scoped="scoped">
  .column-tag {
    margin-left: 10px;
  }
</style>
